import React from 'react';
import { GiHumanTarget, GiTreehouse, GiGraduateCap, GiHeartBeats } from "react-icons/gi";

// Icons matching each feature
const icons = [
  GiHumanTarget,       // 1. Better Human Being
  GiTreehouse,         // 2. Pollution Free Campus
  GiGraduateCap,       // 3. Fun & Engaging Learning
  GiHeartBeats         // 4. Holistic Development
];

const featureBoxes = [
  {
    id: 1,
    color: "rgb(248, 0, 0)",
    title: "Making A Better Human Being",
    text: "Education is not just about academics. It's about character building. We instill values like kindness, honesty, and responsibility to shape well-rounded individuals who contribute positively to society."
  },
  {
    id: 2,
    color: "rgb(56, 142, 60)",
    title: "Pollution Free Campus",
    text: "We believe that a clean and green environment enhances learning. Our campus is designed to be eco-friendly, promoting sustainability through tree plantations, waste management, and pollution control initiatives."
  },
  {
    id: 3,
    color: "rgb(25, 118, 210)",
    title: "Fun & Engaging Learning",
    text: "We make education fun and engaging through interactive methods such as group discussions, role-playing, field trips, and creative projects, ensuring that every child learns in an enjoyable and meaningful way."
  },
  {
    id: 4,
    color: "rgb(251, 192, 45)",
    title: "Holistic Development",
    text: "Our holistic approach to education ensures that students develop critical thinking, leadership skills, and a sense of social responsibility. We empower students to excel in all aspects of life and become confident, compassionate global citizens."
  },
];

function FeatureBox({ color, title, text, icon: Icon }) {
  return (
    <div 
      className="feature-box-new" 
      style={{ backgroundColor: color }}
    >
      <div className="icon-center">
        <svg
          className="feature-icon-new"
          width="70"
          height="70"
          viewBox="0 0 24 24"
        >
          {/* Circle background - same color as the box */}
          <circle cx="12" cy="12" r="11" fill={color} />
          
          {/* Optional: subtle white stroke/outline for better visibility */}
          <circle 
            cx="12" 
            cy="12" 
            r="11" 
            fill="none" 
            stroke="rgba(255,255,255,0.3)" 
            strokeWidth="1.5"
          />
          
          {/* The actual icon - white color for contrast */}
          {Icon && <foreignObject x="0" y="0" width="24" height="24">
            <div style={{ color: 'white', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon size={24} />
            </div>
          </foreignObject>}
        </svg>
      </div>

      <h3 className="feature-title-new">{title}</h3>
      <p className="feature-text-new">{text}</p>
    </div>
  );
}

function BoxContainer() {
  return (
    <div className="features-container-new container">
      <div className="boxes-wrapper-new">
        {featureBoxes.map((box, index) => (
          <FeatureBox
            key={box.id}
            color={box.color}
            title={box.title}
            text={box.text}
            icon={icons[index]}
          />
        ))}
      </div>
    </div>
  );
}

export default BoxContainer;